export default __webpack_public_path__ + "static/media/13.f8a9db10.jpg";